import ASTBlock from "../ASTBlock";
import Blockly from 'blockly';

export default class booleanBlock extends ASTBlock {
    constructor(color) {
        super(color, "booleanblock")
        this.predefinedInputs = {}
        this.TOP_LEVEL = undefined
    }

    addToBlockly() {
        var json = {
            "tooltip": "",
            "helpUrl": "",
            "message0": "%1 %2",
            "args0": [{
                    "type": "field_dropdown",
                    "name": "NAME",
                    "options": [
                        [
                            "wahr",
                            "True"
                        ],
                        [
                            "falsch",
                            "False"
                        ]
                    ]
                },
                {
                    "type": "input_dummy",
                    "name": "NAME"
                }
            ],
            "output": "Boolean"
        }

        let that = this
        Blockly.Blocks[this.name] = {
            init: function() {
                this.jsonInit(json);
                this.setColour(that.color)
            }

        }
    }
}